var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2"},[_c('router-link',{attrs:{"to":{ name: 'blogshow', params: { id: _vm.article.id, url: _vm.article.url } }}},[_vm._v("\n    "+_vm._s(_vm.article.title)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }